import { useCallback } from 'react';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';

export function useBack(param: string): () => void {
    const { state } = useLocation();
    const { url } = useRouteMatch();
    const history = useHistory();

    return useCallback(() => {
        if (state) {
            // user came here from within the application
            history.goBack();
        } else {
            // user came here from a bookmark or a direct link outside of the application
            const backURL = url.replace(`/${param}`, '');
            history.replace(backURL);
        }
    }, [url, state, history, param]);
}
